import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import AppSidebar from './AppSidebar';

export default function MobileNavigationDrawer({ groups, pathname, onClose, triggerRef }) {
    const dialogRef = useRef(null);
    useEffect(() => {
        const dialog = dialogRef.current;
        const trigger = triggerRef.current;
        dialog.querySelector('button').focus();
        const handleKey = event => {
            if (event.key === 'Escape') { event.preventDefault(); onClose(); }
            if (event.key !== 'Tab') return;
            const items = [...dialog.querySelectorAll('button:not([disabled]), a[href]')];
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
                event.preventDefault(); last.focus();
            } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
                event.preventDefault(); first.focus();
            }
        };
        document.addEventListener('keydown', handleKey);
        return () => { document.removeEventListener('keydown', handleKey); trigger?.focus(); };
    }, [onClose, triggerRef]);

    return createPortal(
        <div data-testid="navigation-backdrop" className="fixed inset-0 z-[100] flex justify-start bg-black/60 lg:hidden" onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
            <div id="navigation-dialog" ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="navigation-title"
                className="flex h-full w-72 max-w-[calc(100vw-2rem)] flex-col border-r border-secondary-200 bg-white text-secondary-800 shadow-2xl dark:border-secondary-700 dark:bg-secondary-800 dark:text-secondary-100">
                <div className="flex shrink-0 items-center justify-between border-b border-secondary-200 p-4 dark:border-secondary-700">
                    <h2 id="navigation-title" className="text-lg font-bold">Menú</h2>
                    <button type="button" onClick={onClose} aria-label="Cerrar menú" className="rounded-lg p-2 hover:bg-secondary-100 focus-visible:outline-purple-500 dark:hover:bg-secondary-700"><X size={20} /></button>
                </div>
                <AppSidebar groups={groups} pathname={pathname} onNavigate={onClose} />
            </div>
        </div>, document.body
    );
}
